import $ from 'jquery';

export default class Page {
  static get selector() {
    return 'meta[name=page]';
  }

  static id() {
    return $(this.selector).data('id');
  }

  static type() {
    return $(this.selector).data('type');
  }

  static className() {
    return $(this.selector).data('className');
  }
}
